module.exports = __webpack_public_path__ + "img/mail-login-banner.528f1a96.svg";